let markerVis = false;


const paralax = {
  class : '.prlx',
  timelines: [],
  init: function(cont = document){
      let obj = this;
      let $items = $(obj.class);
      if($items.length > 0){

          $.each($items, function(){
              let $item = $(this);
              let tl = gsap.timeline({
                  force3D: true,
                  scrollTrigger: {
                      trigger: $item[0],
                      markers: false,
                      start: "top 90%",
                      scrub: 1,
                  }})

              if($item.data('prlx') === 'right-left'){
                  let $img = $item.find('img');
                  tl.fromTo($img,
                      {
                          x:0
                      },
                      {
                          x: -($img.width() - $item.width())
                      });
              }
              obj.timelines.push(tl);
          });

      }
  },
  resize: function(){
      let obj = this;
      $(window).resize(function(){
          if(obj.timelines.length > 0){
              $.each(obj.timelines, function(){
                  this.kill();
              })
          }
          obj.timelines = [];
          obj.init();
      })
  }
}

const animGlobal = {
  init: () => {

    let $anim = $('.reveal');
    $anim.each(function(){
    let $this = $(this);

        gsap.set($this,{autoAlpha:0});
        gsap.timeline({
            scrollTrigger: {
            trigger: $this[0],
            start: "top 75%", 
            end: "top 60%", 
            markers:markerVis,
            onEnter: function(){
                gsap.fromTo($this,{y: 20},{autoAlpha: 1, y: 0, duration:  $this.data('speed') || 0.6});
            },
            once: true
            }
        });
        
    })

    let $anim1 = $('.reveal-stagger');
    $anim1.each(function(){
      let $this = $(this);
      let speed = $this.data('speed') || 0.2;
      let col = $this.find('> div');
      gsap.set(col, {autoAlpha:0});
      gsap.timeline({
          scrollTrigger: {
          trigger: $this[0],
          start: "top 70%", 
          end: "top 60%", 
          markers:markerVis,
          onEnter: function(){
            gsap.fromTo(col,{y: 30},{autoAlpha: 1, y: 0, duration: 0.6, stagger: speed});
          },
          once: true
          }
      });
        
    })


    // let $anim3 = $('.reveal-stagger-table');
    // $anim3.each(function(){
    //   let $this = $(this);
    //   let speed = $this.data('speed') || 0.1;
    //   let col = $this.find('tr');
    //   gsap.set(col, {autoAlpha:0});
    //   gsap.timeline({
    //       scrollTrigger: {
    //       trigger: $this[0],
    //       start: "top 80%", 
    //       end: "top 60%", 
    //       markers:markerVis,
    //       onEnter: function(){
    //         gsap.fromTo(col,{y: 100},{autoAlpha: 1, y: 0, duration: 0.3, stagger: speed});
    //       },
    //       once: true
    //       }
    //   });
        
    // })

    let $anim2 = $('.reveal-stagger-custom');
    $anim2.each(function(){
      let $this = $(this);
      let speed = $this.data('speed') || 0.3;
      let col = $this.find(' .stagger');
      gsap.set(col, {autoAlpha:0});
      gsap.timeline({
          scrollTrigger: {
          trigger: $this[0],
          start: "top 60%", 
          end: "top 50%", 
          markers:markerVis,
          onEnter: function(){
            gsap.fromTo(col,{y: 30},{autoAlpha: 1, y: 0, duration: 0.6, stagger: speed});
          },
          once: true
          }
      });
        
    })
    
  },
  initTitles: function(){
    let titles = $(".titleAnim");
    titles.each(function () {
      let $el = $(this);
      let split = new SplitText($el, {type:"chars,words", charsClass:"chAnim"});
      split.chars.forEach(function(elm, idx){
        elm.style.setProperty("--anim-delay", `${25*idx}ms`);
      });
      let tl = gsap.timeline({
        paused: true,
        scrollTrigger: {
          trigger: $el,
          start: "top 90%",
          end: "bottom 50%",
          onEnter: function(){
            $el.addClass("visible");
          },
          once: true
        }
      });

      tl.fromTo(split.chars, {x:"10vw", scale:0.95}, {duration:1.5, x:0, ease:"expo.out", scale:1.001, stagger:0.015},0);
      tl.fromTo(split.chars, {opacity:0}, {duration:1, opacity:1, ease:"power4.out", stagger:0.016},0);

    });
  },
  initTitle: function(){
    let titles = $(".titleMainAnim");
    titles.each(function () {
      let $el = $(this);
      let split = new SplitText($el, {type:"chars,words", charsClass:"chAnim"});
      split.chars.forEach(function(elm, idx){
        elm.style.setProperty("--anim-delay", `${585*idx}ms`);
      });
      let tl = gsap.timeline({
        paused: true,
        scrollTrigger: {
          trigger: $el,
          start: "top 90%",
          end: "bottom 50%",
          onEnter: function(){
            $el.addClass("visible");
          },
          once: true
        }
      });

      tl.fromTo(split.chars, {y:"10vw", scale:0.95}, {duration:2.5, y:0, ease: 'power4.out', scale:1.001, stagger:0.015},0);
      tl.fromTo(split.chars, {opacity:0}, {duration:1.5, opacity:0.5, ease:"power4.out", stagger:0.016},0);

      setTimeout((chars) => {
        let tl = gsap.timeline({});
        tl.fromTo(chars, {opacity:0.5}, {duration:1.5, opacity:1, ease:"power4.out", stagger:0.056},0);
      },1100,split.chars);
    });
  }
};

const animIndex = {
    init: () => {
        if($('.homepage').length === 0) return;
        // buuble
        let $content = $('.content');
        let $cols = $content.find('.col-js');
        let $bubble = $('.about-section-1 .bubble');

        gsap.set($cols, {autoAlpha:0});
        gsap.set($bubble,{autoAlpha:0,width: '240px', height: '240px'});

        gsap.timeline({
            scrollTrigger: {
            trigger: $content[0],
            start: "top 65%", 
            end: "top 60%", 
            markers:markerVis,
            onEnter: function(){
                gsap.fromTo($cols,{y: 30},{autoAlpha: 1, y: 0, duration: 0.6, stagger: 0.4});
                gsap.fromTo($bubble,{autoAlpha: 1,width: '240px', height: '240px'},{ width: '100%', height: '100%', duration: 0.6});
            },
            once: true
            }
        });

        // first photos
        ScrollTrigger.matchMedia({
	
          // large
          "(min-width: 960px)": function() {
            gsap.to(".section1-img1", {
              xPercent: 2,
              ease: Power0.easeInOut,
              scrollTrigger: {
                markers:markerVis,
                trigger: ".section1-img2",
                start: "top 65%", 
                end: "bottom 30%", 
                scrub: true
              }, 
            });
            
            gsap.to(".section1-img2", {
              xPercent: -2,
              ease: Power0.easeInOut,
              scrollTrigger: {
                markers:markerVis,
                trigger: ".section1-img1",
                start: "top 65%", 
                end: "bottom 30%", 
                scrub: true
              }, 
            });
    
            gsap.to(".section1-img3", {
              yPercent: -14,
              ease: Power0.easeInOut,
              scrollTrigger: {
                markers:markerVis,
                trigger: ".section1-img2",
                start: "top 45%", 
                end: "bottom 20%", 
                scrub: true
              }, 
            });
          },
          

          "(max-width: 959px)": function() {
            gsap.set('.section1-img3',{autoAlpha:0});
            gsap.timeline({
                scrollTrigger: {
                trigger: '.section1-img3',
                start: "top 50%", 
                end: "top 4\0%", 
                markers:markerVis,
                onEnter: function(){
                    gsap.fromTo('.section1-img3',{y: 0},{autoAlpha: 1, y: -40, duration:  1.2});
                },
                once: true
                }
            });
          },
          "all": function() {
          }
          
        }); 



        //Ramybės ritualai namuose
        //section-2img
        gsap.to(".section-2img img", {
          yPercent: 8,
          ease: "none",
          scrollTrigger: {
            markers:markerVis,
            trigger: '.section-2img',
            start: "top bottom", 
            end: "top 40%", 
            scrub: true
          }, 
        });

     
        //second buuble after ŠV. STEPONO SKVERAS

        // buuble
        let $content1 = $('.part2');
        let $cols1 = $content.find('.col-js');
        let $bubble1 = $('.part2 .bubble');

        gsap.set($cols1, {autoAlpha:0});
        gsap.set($bubble1,{autoAlpha:0,width: '240px', height: '240px'});

        gsap.timeline({
            scrollTrigger: {
            trigger: $content1[0],
            start: "top 65%", 
            end: "top 60%", 
            markers:markerVis,
            onEnter: function(){
                gsap.fromTo($cols1,{y: 30},{autoAlpha: 1, y: 0, duration: 0.6, stagger: 0.4});
                gsap.fromTo($bubble1,{autoAlpha: 1,width: '240px', height: '240px'},{ width: '100%', height: '100%', duration: 0.6});
            },
            once: true
            }
        });

        gsap.to(".about-section-3 .img-box-anim img", {
          xPercent: -2,
          ease: Power0.easeInOut,
          scrollTrigger: {
            markers:markerVis,
            trigger: '.skvero-map',
            start: "top 45%", 
            end: "top 10%", 
            scrub: true
          }, 
        });

        //Jūsų gyvenimo kokybę keičiantys namai
        gsap.to(".image-text img", {
          yPercent: 8,
          ease: Power0.easeInOut,
          scrollTrigger: {
            markers:markerVis,
            trigger: '.image-text',
            start: "top bottom", 
            end: "top 40%", 
            scrub: true
          }, 
        });

        // section 4
        gsap.to(".about-section-4 .block-2-list .item:first-child .img", {
          yPercent: -10,
          ease: "none",
          scrollTrigger: {
            markers:false,
            trigger: '.about-section-4 .block-2-list .item:first-child',
            start: "top 10%", 
            end: "bottom 5%", 
            scrub: true
          }, 
        });

        gsap.to(".about-section-4 .block-2-list .item:last-child .img", {
          xPercent: -15,
          ease: "none",
          scrollTrigger: {
            markers:false,
            trigger: '.about-section-4 .block-2-list .item:last-child',
            start: "top 10%", 
            end: "bottom 5%", 
            scrub: true
          }, 
        });

        gsap.to(".about-section-4 .block-2-list .item:last-child .large", {
          yPercent: -15,
          ease: "none",
          scrollTrigger: {
            markers:false,
            trigger: '.about-section-4 .block-2-list .item:last-child',
            start: "top 10%", 
            end: "bottom 5%", 
            scrub: true
          }, 
        });

        //as2-header persiklojancios antrastes
        $(".as2-header").each(function () {
          $(this).find("div").each(function(id,el){
            let sPos = 3 * (id%2>0?-1:1);
            gsap.fromTo(el, {xPercent:-sPos}, {xPercent:sPos*2, duration:1,ease:"none", scrollTrigger:{
              trigger: el,
              start: "top bottom",
              end: "bottom top",
              scrub: true
            }});
          });
        });

    }
};


const apartmanetIndex = {
  init: () => {
    if($('.houses-visual').length === 0) return;

    let $fs = $('.houses-visual svg a[data-anim="s"]');
    let time = 120;
    let i = 1;

    //console.log($fs);

    $('.houses-visual svg a').addClass('svg-special');

    setTimeout(function(){
    $fs.each(function() {
      let $this = $(this);

      setTimeout((i) => {
        $(`#S${i}`).addClass('svg-hightlight');
        setTimeout((i) => {
          $(`#S${i}`).removeClass('svg-hightlight');
        },380, i);
      },time, i);

      setTimeout((i) => {
        $(`#P${i}`).addClass('svg-hightlight');
        setTimeout((i) => {
          $(`#P${i}`).removeClass('svg-hightlight');
        },380, i);
      },time, i);

      setTimeout((i) => {
        $(`#A${i}`).addClass('svg-hightlight');
        setTimeout((i) => {
          $(`#A${i}`).removeClass('svg-hightlight');
        },380, i);
      },time, i);
      
      time +=160;
      i++;
      
    })

    setTimeout(() => $('.house-tooltip.p').addClass('house-tooltip-show'),(time + 200));
    setTimeout(() => $('.house-tooltip.s').addClass('house-tooltip-show'),(time + 200));
    setTimeout(() => $('.house-tooltip.a').addClass('house-tooltip-show'),(time + 200));
    setTimeout(() => $('.house-tooltip.k').addClass('house-tooltip-show'),(time + 200));
    $('.houses-visual svg a').removeClass('svg-special');
  }, 300)
  }
}

const animFavorite = {
  init: () => {
    if($('.favorites-page').length === 0) return;
    gsap.to(".favorite-img0", {
      xPercent: -4,
      ease: "none",
      scrollTrigger: {
        markers:false,
        trigger: '.content-container',
        start: "top 80%", 
        end: "bottom 70%", 
        scrub: true
      }, 
    });

    gsap.to(".favorite-img1", {
      xPercent: 8,
      ease: "none",
      scrollTrigger: {
        markers:false,
        trigger: '.content-container',
        start: "top 90%", 
        end: "bottom 70%", 
        scrub: true
      }, 
    });

  }
}

window.smooth = null;
$(document).ready(function() {
  window.smooth = ScrollSmoother.create({
    smooth: 1,   
    effects: false
  });

  //CustomCursor.init();
  animGlobal.init();
  //introControl.init();
  animGlobal.initTitles();
  animGlobal.initTitle();
  animIndex.init();
  animFavorite.init();
  paralax.init();

  apartmanetIndex.init();

  let dl = $(".intro.homepage").length > 0 ? 1500 : 0;
  setTimeout(function(){
    $(".site-header").addClass("visible");
  }, dl);
});

//console.log("!");